import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Fieldset } from 'primereact/fieldset'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomMultiSelect,
  CustomPanel,
  InputText,
  Loading,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import * as PickingHttp from '../../../../services/api/https/picking/picking.http'
import * as AreaHttp from '../../../../services/api/https/picking/picking-area.http'
import { tableCellCentered } from '../../../../assets/js/styles'
import { errorHandler } from '../../../../services/util/error.service'
import { sortBy } from '../../../../services/util/array.service'
import {
  urlReportPickListApuracao,
  urlReportPickListConsolidado,
  urlReportPickListPorArea,
} from '../../../../services/api/routes/picking.routes'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { buildUfOptions, normalizeUf } from '../../../../services/util/estados.service'
import _ from 'lodash'
import ModalClientesSemRotaDeEntrega from '../ModalClientesSemRotaDeEntrega/ModalClientesSemRotaDeEntrega'
import ModalListaProdutos from './ModalListaProdutos'
import { SplitButton } from 'primereact/splitbutton'

class AssocAreaSeparacao extends Component {
  metodosAssociacao = [
    { label: '01 Associar um Cliente por Área', value: 'ACA' },
    { label: '02 Importação de Arquivo Homologado', value: 'IAH' },
    { label: '03 Associar Cliente por Área Por Rota', value: 'ACAR' },
    { label: '04 Associar um Cliente por Área COM Apelido', value: 'ACAAP' },
    { label: '05 Associar um Identificador Por Área', value: 'AIPA' },
    { label: '06 Associar A partir Placa Prevista Carregamento', value: 'APPC' },
    { label: '07 Utilizar Cliente Associado a Área', value: 'UCAA' },
    { label: '08 Associar A partir Info Complementar', value: 'APIC' },
    { label: '09 Associar Um Identificador por Area com Placa Prevista', value: 'APPC2' },
    { label: '10 Associar Cidade por Área Por Rota', value: 'ACAR2' },
    { label: '11 Associar Um Cliente por Area com Placa Prevista', value: 'ACAPP' },
    { label: '12 Associar Áreas por UF', value: 'AAU' },
    { label: '13 Associar Áreas por Cidade', value: 'AAC' },
  ]

  menuItems = ['Itens']

  state = {
    areas: [],
    entregas: [],
    isLoanding: true,
    selectedArea: '',
    apelido: '',
    globalFilter: '',
    mostrarAssocAutomaticas: false,
    selectedMetodoAssociacao: '',
    disableControls: false,
    modalClienteSemRota: {
      show: false,
      data: {
        clientesSemRotaDeEntrega: [],
        rotasEntrega: [],
      },
    },
    selecionarTodos: false,
    selectedUfs: [],
    ufOptions: [],
    selectedCities: [],
    citiesOptions: [],
    selectedBairros: [],
    bairrosOptions: [],
    selectedInfoComplementar: [],
    infoComplementarOptions: [],
    modalListaProdutos: {
      show: false,
      entrega: null,
    },
  }

  onBtnPickListClicked = () => {
    const { selectedPicking } = this.props
    const entregasSemArea = this.state.entregas.filter(e => !e.area)
    if (entregasSemArea.length > 0) {
      this.props.dispatch(showMessageBox(null, 'Existe Entrega sem Área Associada'))
    } else {
      const url = urlReportPickListPorArea(selectedPicking.id)
      window.open(url, '_blank')
    }
  }

  onBtnPickListSintetico = () => {
    const { selectedPicking } = this.props
    const entregasSemArea = this.state.entregas.filter(e => !e.area)
    if (entregasSemArea.length > 0) {
      this.props.dispatch(showMessageBox(null, 'Existe Entrega sem Área Associada'))
    } else {
      const url = urlReportPickListConsolidado(selectedPicking.id)
      window.open(url, '_blank')
    }
  }

  onBtnPickListApuracao = () => {
    const { selectedPicking } = this.props
    const entregasSemArea = this.state.entregas.filter(e => !e.area)
    if (entregasSemArea.length > 0) {
      this.props.dispatch(showMessageBox(null, 'Existe Entrega sem Área Associada'))
    } else {
      const url = urlReportPickListApuracao(selectedPicking.id)
      window.open(url, '_blank')
    }
  }

  splitButtonsItems = [
    {
      label: '02. Pick List Consolidado ',
      command: () => this.onBtnPickListSintetico(),
    },
    {
      label: '03. Pick List Apuração',
      command: () => this.onBtnPickListApuracao(),
    },
  ]

  // Events
  onChangeGlobalFilter = value => {
    this.setState(prevState => ({ ...prevState, globalFilter: value }))
  }

  onBtnVoltar = () => {
    this.props.history.goBack()
  }

  onCheckBoxRowClicked = entrega => {
    entrega.selected = !entrega.selected
    this.setState(state => {
      const { entregas } = state
      const index = entregas.find(e => e.delivery_id === entrega.delivery_id)
      if (index !== -1) {
        entregas[index] = entrega
        return { ...state, entregas }
      }
      return state
    })
  }

  _runAssociarIdentificadorPorArea = () => {
    const {
      selectedPicking: { status },
    } = this.props

    if (
      status === 'Pronto Para Download' ||
      status === 'Picking Concluido' ||
      status === 'Resumo Emitido' ||
      status === 'Concluido Parcialmente'
    ) {
      this.props.dispatch(
        showMessageBox(null, `Não é possível associar as Área. O status do Picking é: ${status}`),
      )
    } else {
      this.setState(prevState => {
        const { entregas, areas } = prevState
        if (entregas.length > areas.length) {
          const qteDeAreasParaCadastrar = entregas.length - areas.length
          this.props.dispatch(
            showMessageBox(null, `Você precisa cadastrar mais: ${qteDeAreasParaCadastrar} área(s)`),
          )
        } else {
          const entregasOrdenadasPorQte = entregas.sort((a, b) => b.qteSkuTotal - a.qteSkuTotal)
          entregasOrdenadasPorQte.forEach((e, index) => {
            const area = areas.find(a => a.sequence === index + 1)
            if (area) {
              const { id, name } = area
              e.area = { id, name }
              e.area_id = id
            }
          })
        }
        return prevState
      })
    }
  }

  onBtnSalvarClicked = async () => {
    try {
      this._checkIfAllEntregaTemAreaAssociada()

      // 'ACAR' - Associação das Área Por Rota de Entrega
      // Nesse caso o processo é realizado durante o clique do Button Associar
      if (this.state.selectedMetodoAssociacao.value !== 'ACAR') {
        const info = this._buildInfo()
        const { selectedPicking } = this.props
        const isReconferencia = selectedPicking && selectedPicking.style === 'Reconferencia'
        const picking_id = selectedPicking ? selectedPicking.id : null
        await PickingHttp.associateDeliveryToAreas(info, isReconferencia, picking_id)
      }
      this.props.dispatch(showMessageBox('Operação realizada com sucesso !', null))
    } catch (error) {
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  onBtnAssociarClicked = () => {
    try {
      const { mostrarAssocAutomaticas } = this.state
      if (!mostrarAssocAutomaticas) {
        this._associarManualmente()
      } else {
        this._associarAutomaticamente()
      }
    } catch (error) {
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  onFormControlChange = (name, value) => {
    this.setState(state => (state[name] = value))
  }

  onMetodoAssociacaoChange = metodo => {
    const {
      selectedPicking: { id: picking_id },
    } = this.props
    const { value } = metodo
    switch (value) {
      case 'ACA':
        this.setState({ selectedMetodoAssociacao: metodo })
        break
      case 'ACAAP':
        this.setState({ selectedMetodoAssociacao: metodo })
        break
      case 'ACAR':
        this.setState({ selectedMetodoAssociacao: metodo })
        break
      case 'ACAR2':
        this.setState({ selectedMetodoAssociacao: metodo })
        break
      case 'IAH':
        this.props.history.push('/main/picking/assoc-area-import-excel', { picking_id })
        break
      case 'AIPA':
        this.setState({ selectedMetodoAssociacao: metodo })
        break
      case 'APPC':
        this.props.history.push('/main/picking/assoc-area-placa-prevista-carregamento', {
          picking_id,
        })
        break
      case 'UCAA':
        this.setState({ selectedMetodoAssociacao: metodo })
        break
      case 'APIC':
        this.setState({ selectedMetodoAssociacao: metodo })
        break
      case 'APPC2':
        this.setState({ selectedMetodoAssociacao: metodo })
        break
      case 'ACAPP':
        this.setState({ selectedMetodoAssociacao: metodo })
        break
      case 'AAU':
        this.setState({ selectedMetodoAssociacao: metodo })
        break
      case 'AAC':
        this.setState({ selectedMetodoAssociacao: metodo })
        break
      default:
        break
    }
  }

  onUtilizarClienteAssocAreaSelected = () => {
    const { areas, entregas } = this.state

    entregas.forEach(entrega => {
      const { client_id, nomeFantasia, identifier } = entrega
      const area = areas.find(a => a.client_id === client_id)
      if (!area) {
        throw new Error(
          `O cliente ${nomeFantasia} - ${identifier} não está associado a nenhuma Área de Separação`,
        )
      }
      entrega.area = area
    })

    this.setState({ entregas })
  }

  onBtnTagPalletClicked = () => {
    const { selectedPicking } = this.props
    const entregasSemArea = this.state.entregas.filter(e => !e.area)
    if (entregasSemArea.length > 0) {
      this.props.dispatch(showMessageBox(null, 'Existe Entrega sem Área Associada'))
    } else {
      this.props.history.push('/main/picking/tag-pallet', {
        picking_id: selectedPicking.id,
      })
    }
  }

  onBtnExportar = () => {
    const columns = [
      [
        'Index',
        'Nome Fantasia',
        'Cidade',
        'UF',
        'Bairro',
        'Identificador',
        'Qte Cxs',
        'Peso',
        'Área',
        'Apelido',
      ],
    ]
    const entregas = sortBy([...this.state.entregas], 'sequence')
    entregas.forEach(e => {
      columns.push([
        e.delivery_step_id,
        e.nomeFantasia,
        e.city_name,
        e.uf,
        e.district,
        e.identifier,
        e.qteSkuTotal,
        e.weightTotal,
        e.sequence,
        e.area_nickname,
      ])
    })
    const fileName = this.props.selectedPicking.name.toLowerCase().replace(' ', '_')
    gerarArquivoExcel('entregas', columns, `${fileName}.xlsx`)
  }

  onChangeSelecionarTodos(selecionado) {
    this.setState(state => {
      const entregas = this.state.entregas.map(entrega => ({ ...entrega, selected: selecionado }))
      return { ...state, entregas, selecionarTodos: selecionado }
    })
  }

  updateLocationFilters = entregas => {
    const hasUf = entregas.some(e => !!e.uf)
    const ufOptions = hasUf ? buildUfOptions(entregas, 'uf') : []

    const allCities = [...new Set(entregas.map(e => e.city_name).filter(Boolean))]
      .sort()
      .map(c => ({ label: c, value: c }))

    const allInfoComplementar = [...new Set(entregas.map(e => e.info_complementar).filter(Boolean))]
      .sort()
      .map(info => ({ label: info, value: info }))

    this.setState({
      ufOptions,
      citiesOptions: allCities,
      infoComplementarOptions: allInfoComplementar,
      selectedUfs: [],
      selectedCities: [],
      selectedBairros: [],
      selectedInfoComplementar: [],
      bairrosOptions: [],
    })
  }

  onUfChange = selectedUfs => {
    const { entregas } = this.state

    let filtered = entregas
    if (selectedUfs.length) {
      filtered = filtered.filter(t => selectedUfs.includes(normalizeUf(t.uf)))
    }

    const cities = [...new Set(filtered.map(t => t.city_name).filter(Boolean))]
      .sort()
      .map(c => ({ label: c, value: c }))

    this.setState({
      selectedUfs,
      citiesOptions: cities,
      selectedCities: [],
      selectedBairros: [],
      selectedInfoComplementar: [],
      bairrosOptions: [],
    })
  }

  onCityChange = selectedCities => {
    const { entregas, selectedUfs } = this.state

    let filtered = entregas
    if (selectedUfs.length) {
      filtered = filtered.filter(t => selectedUfs.includes(normalizeUf(t.uf)))
    }
    if (selectedCities.length) {
      filtered = filtered.filter(t => selectedCities.includes(t.city_name))
    }

    const bairros = [...new Set(filtered.map(t => t.district).filter(Boolean))]
      .sort()
      .map(b => ({ label: b, value: b }))

    this.setState({
      selectedCities,
      bairrosOptions: bairros,
      selectedBairros: [],
      selectedInfoComplementar: [],
    })
  }

  onBairroChange = selectedBairros => {
    this.setState({ selectedBairros })
  }

  onInfoComplementarChange = selectedInfoComplementar => {
    this.setState({ selectedInfoComplementar })
  }

  getLocationFilteredEntregas = () => {
    const {
      entregas,
      ufOptions,
      selectedUfs,
      selectedCities,
      selectedBairros,
      selectedInfoComplementar,
    } = this.state
    let data = entregas || []

    if (ufOptions.length && selectedUfs.length) {
      data = data.filter(t => selectedUfs.includes(normalizeUf(t.uf)))
    }
    if (selectedCities.length) {
      data = data.filter(t => selectedCities.includes(t.city_name))
    }
    if (selectedBairros.length) {
      data = data.filter(t => selectedBairros.includes(t.district))
    }
    if (selectedInfoComplementar.length) {
      data = data.filter(t => selectedInfoComplementar.includes(t.info_complementar))
    }
    return data
  }

  onMenuItemClicked = (menuItem, entrega) => {
    if (menuItem === 'Itens') {
      this.setState({ modalListaProdutos: { show: true, entrega } })
      return
    }
    this.props.dispatch(showMessageBox(null, 'Menu Item - ação não cadastrada'))
  }

  onCloseListaProdutos = () => {
    this.setState({ modalListaProdutos: { show: false, entrega: null } })
  }

  // Life cycle
  componentDidMount = async () => {
    try {
      const {
        selectedPicking: { id, tp_id },
      } = this.props
      const [areas, entregas] = await Promise.all([
        AreaHttp.getAreas(tp_id),
        PickingHttp.getDeliveriesForAreaAndTeamAssociation(id),
      ])

      const sortedEntregas = sortBy(entregas, 'sequence')

      this.setState({
        areas,
        entregas: sortedEntregas,
        isLoanding: false,
        selectedArea: areas.length === 0 ? '' : areas[0],
      })

      this.updateLocationFilters(sortedEntregas)
    } catch (error) {
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  // Render
  render() {
    const { selectedPicking } = this.props
    const {
      isLoanding,
      areas,
      selectedArea,
      apelido,
      mostrarAssocAutomaticas,
      selectedMetodoAssociacao,
      disableControls,
    } = this.state
    return (
      <div>
        <PageHeader>
          <span>
            {selectedPicking && selectedPicking.style === 'Manual'
              ? '4.4.4'
              : selectedPicking && selectedPicking.style === 'Reconferencia'
                ? '4.8.4'
                : '4.3.4'}{' '}
            - Associação de Entregas X Áreas de Separação:
          </span>
          <strong>
            {selectedPicking ? `${selectedPicking.name} - ${selectedPicking.company_name}` : ''}
          </strong>
        </PageHeader>
        <div style={{ marginTop: 20 }}>
          <CustomPanel
            onNovo={this.onBtnSalvarClicked}
            btnLabel="Salvar"
            onVoltar={this.onBtnVoltar}
          >
            <div className="p-grid">
              <div className="p-col-2">
                <CustomDropdown
                  disabled={disableControls}
                  marginTop={0}
                  optionLabel="name"
                  options={areas}
                  value={selectedArea}
                  onChange={value => this.onFormControlChange('selectedArea', value)}
                />
              </div>
              <div className="p-col-2">
                <InputText
                  disabled={disableControls}
                  showLabel={false}
                  marginTop={0}
                  placeholder="Apelido da Área"
                  value={apelido}
                  onChange={value => this.onFormControlChange('apelido', value)}
                />
              </div>
              <div className="p-col-8">
                <Btn onClick={this.onBtnAssociarClicked}>Associar</Btn>

                  
                    <div style={{ display: 'inline-block', marginLeft: 10 }}>
                      <Btn onClick={this.onBtnTagPalletClicked}>Tag Pallet</Btn>
                    </div>
                    <div style={{ display: 'inline-block', marginLeft: 10 }}>
                      <SplitButton
                        menuStyle={{ width: 250 }}
                        className="bck-primary"
                        label="01. Pick List Por Área"
                        icon="pi pi-tags"
                        onClick={() => this.onBtnPickListClicked()}
                        model={this.splitButtonsItems}
                      />
                    </div>
                    <div style={{ display: 'inline-block', marginLeft: 10 }}>
                      <Btn onClick={this.onBtnExportar}>Exportar</Btn>
                    </div>
                  
              </div>
              <div className="p-col-2" style={{ paddingTop: 20 }}>
                <CustomCheckbox
                  checked={this.state.selecionarTodos}
                  onChange={() => this.onChangeSelecionarTodos(!this.state.selecionarTodos)}
                >
                  Selecionar Todos
                </CustomCheckbox>
              </div>
              <div className="p-col-4" style={{ paddingTop: 20 }}>
                <CustomCheckbox
                  checked={mostrarAssocAutomaticas}
                  onChange={value =>
                    this.setState({
                      mostrarAssocAutomaticas: value,
                      selectedMetodoAssociacao: '',
                      disableControls: value,
                    })
                  }
                >
                  Mostrar Métodos de Associações Automáticas
                </CustomCheckbox>
              </div>
              <div
                className="p-col-4"
                style={{
                  display: mostrarAssocAutomaticas ? 'block' : 'none',
                }}
              >
                <CustomDropdown
                  showLabel={true}
                  label="Métodos de Associação de Cliente as Áreas"
                  marginTop={0}
                  optionLabel="label"
                  options={
                    selectedPicking && selectedPicking.style === 'Reconferencia'
                      ? this.metodosAssociacao.filter(
                          m =>
                            m.value === 'ACA' ||
                            m.value === 'AIPA' ||
                            m.value === 'ACAAP' ||
                            m.value === 'UCAA' ||
                            m.value === 'APIC' ||
                            m.value === 'APPC2' ||
                            m.value === 'AAU' ||
                            m.value === 'AAC',
                        )
                      : this.metodosAssociacao
                  }
                  value={selectedMetodoAssociacao}
                  onChange={value => this.onMetodoAssociacaoChange(value)}
                />
              </div>
              <div className="p-col-12">
                <Fieldset
                  legend="Filtro"
                  toggleable
                  collapsed={true}
                  className="p-col-12"
                  style={{ marginBottom: 20 }}
                >
                  <div style={{ display: 'flex', gap: 16 }}>
                    {this.state.ufOptions.length > 0 && (
                      <div className="p-col-2" style={{ minWidth: 200 }}>
                        <CustomMultiSelect
                          marginTop={10}
                          label="Estados"
                          options={this.state.ufOptions}
                          value={this.state.selectedUfs}
                          onChange={this.onUfChange}
                        />
                      </div>
                    )}

                    <div className="p-col-2" style={{ minWidth: 200 }}>
                      <CustomMultiSelect
                        marginTop={10}
                        label="Cidades"
                        options={this.state.citiesOptions}
                        value={this.state.selectedCities}
                        onChange={this.onCityChange}
                      />
                    </div>

                    <div className="p-col-2" style={{ minWidth: 200 }}>
                      <CustomMultiSelect
                        marginTop={10}
                        label="Bairros"
                        options={this.state.bairrosOptions}
                        value={this.state.selectedBairros}
                        onChange={this.onBairroChange}
                      />
                    </div>

                    <div className="p-col-2" style={{ minWidth: 200 }}>
                      <CustomMultiSelect
                        marginTop={10}
                        label="Info Complementar"
                        options={this.state.infoComplementarOptions}
                        value={this.state.selectedInfoComplementar}
                        onChange={this.onInfoComplementarChange}
                      />
                    </div>
                  </div>
                </Fieldset>
              </div>
              <div className="p-col-12">
                {isLoanding ? (
                  <div className="text-center">
                    <Loading size="md" />
                  </div>
                ) : (
                  this._dataTable()
                )}
              </div>
            </div>
          </CustomPanel>
        </div>
        <ModalClientesSemRotaDeEntrega
          clientesSemRotaDeEntrega={this.state.modalClienteSemRota.data.clientesSemRotaDeEntrega}
          rotasEntrega={this.state.modalClienteSemRota.data.rotasEntrega}
          isVisible={this.state.modalClienteSemRota.show}
          onClose={() => this._closeModalClienteRotaEntrga()}
          onResponse={(type, payload) => {
            type === 'success'
              ? this._closeModalClienteRotaEntrga()
              : this.props.dispatch(showMessageBox(null, payload))
          }}
        />
        <ModalListaProdutos
          isVisible={this.state.modalListaProdutos.show}
          delivery={this.state.modalListaProdutos.entrega}
          onClose={this.onCloseListaProdutos}
        />
      </div>
    )
  }

  // Helpers
  _dataTable = () => {
    const locationFilteredEntregas = this.getLocationFilteredEntregas()

    return (
      <DataTable
        header={
          <CustomDataTableHeader
            onChange={value => this.onChangeGlobalFilter(value)}
            value={this.state.globalFilter}
          />
        }
        globalFilter={this.state.globalFilter}
        value={locationFilteredEntregas}
        className="auto-layout"
      >
        <Column
          field="selected"
          style={tableCellCentered(50)}
          body={entrega => (
            <CustomCheckbox
              checked={entrega.selected}
              onChange={() => this.onCheckBoxRowClicked(entrega)}
            />
          )}
        />
        <Column field="nomeFantasia" header="Nome Fantasia" />
        <Column field="city_name" header="Cidade" />
        <Column field="uf" header="UF" />
        <Column field="district" header="Bairro" />
        <Column field="identifier" header="Identificador" style={{ textAlign: 'center' }} />
        <Column
          field="qteSkuTotal"
          header="Qte. SKU"
          style={tableCellCentered()}
          body={entrega => entrega.qteSkuTotal.toLocaleString()}
        />
        <Column
          field="weightTotal"
          header="Peso"
          style={tableCellCentered()}
          body={entrega => entrega.weightTotal.toLocaleString()}
        />
        <Column
          header="Área"
          style={tableCellCentered()}
          body={entrega => (
            <span style={{ color: '#e13f3f' }}>{entrega.area ? entrega.area.name : ''}</span>
          )}
        />
        <Column
          header="Área - Apelido"
          body={entrega => <span style={{ color: '#e13f3f' }}>{entrega.area_nickname}</span>}
        />
        <Column
          header="Menu"
          style={tableCellCentered(70)}
          body={entrega => (
            <ThreeDots
              items={this.menuItems}
              onClick={item => this.onMenuItemClicked(item, entrega)}
            />
          )}
          bodyStyle={tableCellCentered()}
        />
      </DataTable>
    )
  }

  _associarManualmente = () => {
    const { entregas, selectedArea, apelido, areas } = this.state

    if (areas.length !== 0) {
      const stepsIds = entregas.filter(e => e.selected).map(i => i.delivery_step_id)
      if (stepsIds.length !== 0) {
        stepsIds.forEach(step_id => {
          const index = entregas.findIndex(e => e.delivery_step_id === step_id)
          if (index !== -1) {
            entregas[index].area = selectedArea
            entregas[index].area_nickname = apelido
            entregas[index].selected = false
          }
        })
        this.setState({ entregas, apelido: '' })
        this.props.dispatch(showMessageBox('Operação realizada com sucesso !', null))
      } else {
        throw new Error('Não Existem Entregas Selecionadas')
      }
    } else {
      throw new Error('Não Existem Áreas de Separação Cadastradas')
    }
  }

  _associarAutomaticamente = () => {
    const { selectedMetodoAssociacao } = this.state
    if (selectedMetodoAssociacao === '')
      throw new Error('Nenhum método foi selecionado. Favor verifique')
    const { value } = selectedMetodoAssociacao

    switch (value) {
      case 'ACA':
        this._associarUmClientePorArea()
        break
      case 'ACAAP':
        this._associarUmClientePorAreaComApelido()
        break
      case 'ACAR':
        this._associarUmClientePorAreaPorRota()
        break
      case 'ACAR2':
        this._associarUmaCidadePorAreaPorRota()
        break
      case 'AIPA':
        this._runAssociarIdentificadorPorArea()
        break
      case 'UCAA':
        this.onUtilizarClienteAssocAreaSelected()
        break
      case 'APIC':
        this._associarAhPartirInfoComplementar()
        break
      case 'APPC2':
        this._associarUmIdentificadorPorAreaComPlaca()
        break
      case 'ACAPP':
        this._associarUmClientePorAreaComPlaca()
        break
      case 'AAU':
        this._associarAreasPorUF()
        break
      case 'AAC':
        this._associarAreasPorCidade()
        break
      default:
        break
    }
  }

  _associarUmClientePorArea = () => {
    const { entregas, areas } = this.state
    // Obter a quantidade de SKU por cliente [{cliente_id: 1, qte_sku: 12312}, ...]
    const clients = this._obterClienteComQteSku(entregas)

    // verificar se a quantidade de Cliente <= que a quantidade de área cadastrada
    if (clients.length > areas.length)
      throw new Error(
        `Cadastre mais ${clients.length - areas.length} área(s) de separação para utilizar este método`,
      )

    // realizar a associacao
    for (let index = 0; index < clients.length; index++) {
      const client = clients[index]
      const area = areas[index]

      const selectedEntregas = entregas.filter(e => e.company_code === client.company_code)

      selectedEntregas.forEach(e => {
        const index = entregas.findIndex(ent => ent.delivery_step_id === e.delivery_step_id)
        if (index !== -1) {
          entregas[index].area = area
        }
      })
    }
    this.setState({ entregas })

    this.props.dispatch(
      showMessageBox('Associação Automática realizada com Sucesso. Favor verifique.', null),
    )
  }

  _associarAreasPorUF = () => {
    const { entregas, areas } = this.state

    const ufs = Array.from(new Set(entregas.map(e => e.uf)))

    if (ufs.length > areas.length)
      throw new Error(
        `Cadastre mais ${ufs.length - areas.length} área(s) de separação para utilizar este método`,
      )

    // realizar a associacao
    for (let index = 0; index < ufs.length; index++) {
      const uf = ufs[index]
      const area = areas[index]

      const selectedEntregas = entregas.filter(e => e.uf === uf)

      selectedEntregas.forEach(e => {
        const index = entregas.findIndex(ent => ent.delivery_step_id === e.delivery_step_id)
        if (index !== -1) {
          entregas[index].area = area
        }
      })
    }
    this.setState({ entregas })

    this.props.dispatch(
      showMessageBox('Associação Automática realizada com Sucesso. Favor verifique.', null),
    )
  }

  _associarAreasPorCidade = () => {
    const { entregas, areas } = this.state
    const cidades = Array.from(new Set(entregas.map(e => e.city_name)))

    if (cidades.length > areas.length)
      throw new Error(
        `Cadastre mais ${cidades.length - areas.length} área(s) de separação para utilizar este método`,
      )

    // realizar a associacao
    for (let index = 0; index < cidades.length; index++) {
      const cidade = cidades[index]
      const area = areas[index]

      const selectedEntregas = entregas.filter(e => e.city_name === cidade)

      selectedEntregas.forEach(e => {
        const index = entregas.findIndex(ent => ent.delivery_step_id === e.delivery_step_id)
        if (index !== -1) {
          entregas[index].area = area
          entregas[index].area_nickname = cidade
        }
      })
    }
    this.setState({ entregas })

    this.props.dispatch(
      showMessageBox('Associação Automática realizada com Sucesso. Favor verifique.', null),
    )
  }

  _associarAhPartirInfoComplementar = () => {
    const { entregas, areas } = this.state

    const getTotalCxsPorInfoComplementar = infoComplementares => {
      const result = []
      infoComplementares.forEach(i => {
        const rows = entregas.filter(e => e.info_complementar === i)
        const ttCxs = rows.reduce((total, item) => total + item.qteSkuTotal, 0)
        result.push({ info_complementar: i, qte_caixas: ttCxs })
      })
      return result.sort((a, b) => b.qte_caixas - a.qte_caixas)
    }

    const infoComplementares = Array.from(new Set(entregas.map(e => e.info_complementar)))

    const totalCxsPorInfoComplementar = getTotalCxsPorInfoComplementar(infoComplementares)

    // verificar se a quantidade de Cliente <= que a quantidade de área cadastrada
    if (infoComplementares.length > areas.length)
      throw new Error(
        `Cadastre mais ${infoComplementares.length - areas.length} área(s) de separação para utilizar este método`,
      )

    for (let i = 0; i < totalCxsPorInfoComplementar.length; i++) {
      const entregasPorInfo = entregas.filter(
        e => e.info_complementar === totalCxsPorInfoComplementar[i].info_complementar,
      )
      entregasPorInfo.forEach(e => {
        e.area_sequence = i
        e.area = areas[i]
        e.area_nickname = totalCxsPorInfoComplementar[i].info_complementar
      })
    }

    this.setState({ entregas: entregas.sort((a, b) => a.area_sequence - b.area_sequence) })

    this.props.dispatch(
      showMessageBox('Associação Automática realizada com Sucesso. Favor verifique.', null),
    )
  }

  _associarUmClientePorAreaComPlaca = async () => {
    const {
      selectedPicking: { status },
    } = this.props
    if (
      status === 'Pronto Para Download' ||
      status === 'Picking Concluido' ||
      status === 'Resumo Emitido' ||
      status === 'Concluido Parcialmente'
    ) {
      this.props.dispatch(
        showMessageBox(null, `Não é possível associar as Área. O status do Picking é: ${status}`),
      )
    } else {
      try {
        this.props.dispatch(showLoadingBox('Realizando a associação...', 'Aguarde:'))
        const {
          selectedPicking: { id: picking_id },
        } = this.props
        const entregas = await PickingHttp.associarUmClientePorAreaComPlacaPrevista(picking_id)
        this.setState({ entregas: sortBy(entregas, 'sequence') })
        this.props.dispatch(showMessageBox('Operação realizada com sucesso !', null))
      } catch (e) {
        this.props.dispatch(showMessageBox(null, errorHandler(e)))
      } finally {
        this.props.dispatch(hideLoadingBox())
      }
    }
  }

  _associarUmIdentificadorPorAreaComPlaca = () => {
    const {
      selectedPicking: { status },
    } = this.props

    if (
      status === 'Pronto Para Download' ||
      status === 'Picking Concluido' ||
      status === 'Resumo Emitido' ||
      status === 'Concluido Parcialmente'
    ) {
      this.props.dispatch(
        showMessageBox(null, `Não é possível associar as Área. O status do Picking é: ${status}`),
      )
    } else {
      this.setState(prevState => {
        const { entregas, areas } = prevState
        if (entregas.length > areas.length) {
          const qteDeAreasParaCadastrar = entregas.length - areas.length
          this.props.dispatch(
            showMessageBox(null, `Você precisa cadastrar mais: ${qteDeAreasParaCadastrar} área(s)`),
          )
        } else {
          const placas = Array.from(new Set(entregas.map(e => e.placa_prevista_carregamento)))
          let areaIndex = 0
          placas.forEach(placa => {
            const entregasOrdenadasPorQte = entregas
              .filter(e => e.placa_prevista_carregamento === placa)
              .sort((a, b) => a.identifier.split('-')[0] - b.identifier.split('-')[0])
            entregasOrdenadasPorQte.forEach((e, index) => {
              const area = areas.find(a => a.sequence === areaIndex + 1)
              if (area) {
                const { id, name } = area
                e.area = { id, name }
                e.area_id = id
                e.area_nickname = `${e.identifier} - ${e.placa_prevista_carregamento}`
              }
              areaIndex++
            })
          })
        }
        return prevState
      })
    }
  }

  _associarUmClientePorAreaComApelido = () => {
    const { entregas, areas } = this.state
    // Obter a quantidade de SKU por cliente [{cliente_id: 1, qte_sku: 12312}, ...]
    const clients = this._obterClienteComQteSku(entregas)

    // verificar se a quantidade de Cliente <= que a quantidade de área cadastrada
    if (clients.length > areas.length)
      throw new Error(
        `Cadastre mais ${clients.length - areas.length} área(s) de separação para utilizar este método`,
      )

    // realizar a associacao
    for (let index = 0; index < clients.length; index++) {
      const client = clients[index]
      const area = areas[index]

      const selectedEntregas = entregas.filter(e => e.company_code === client.company_code)

      selectedEntregas.forEach(e => {
        const index = entregas.findIndex(ent => ent.delivery_step_id === e.delivery_step_id)
        if (index !== -1) {
          entregas[index].area = area
          entregas[index].area_nickname = entregas[index].nomeFantasia
        }
      })
    }
    this.setState({ entregas })

    this.props.dispatch(
      showMessageBox('Associação Automática realizada com Sucesso. Favor verifique.', null),
    )
  }

  _associarUmClientePorAreaPorRota = async () => {
    try {
      this.props.dispatch(showLoadingBox('Realizando a associação...', 'Aguarde:'))

      const {
        selectedPicking: { id: picking_id },
      } = this.props
      const { type, payload } = await PickingHttp.associarAreasDeSeparacaoPorRota(picking_id)

      if (type === 'error') {
        //clientesSemRotaDeEntrega: client_id, nomeFantasia, cidade, bairro
        // rotasEntrega: rota_id, rota_nome
        const { clientesSemRotaDeEntrega, rotasEntrega } = payload
        this.setState({
          modalClienteSemRota: {
            show: true,
            data: { clientesSemRotaDeEntrega, rotasEntrega },
          },
        })
      } else {
        // type === Success
        this.setState({ entregas: sortBy(payload, 'sequence') })
        this.props.dispatch(showMessageBox('Operação realizada com sucesso !', null))
      }
    } catch (e) {
      this.props.dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      this.props.dispatch(hideLoadingBox())
    }
  }

  _associarUmaCidadePorAreaPorRota = async () => {
    try {
      this.props.dispatch(showLoadingBox('Realizando a associação...', 'Aguarde:'))

      const {
        selectedPicking: { id: picking_id },
      } = this.props
      const { type, payload } =
        await PickingHttp.associarAreasDeSeparacaoPorRotaPorCidade(picking_id)

      if (type === 'error') {
        //clientesSemRotaDeEntrega: client_id, nomeFantasia, cidade, bairro
        // rotasEntrega: rota_id, rota_nome
        const { clientesSemRotaDeEntrega, rotasEntrega } = payload
        this.setState({
          modalClienteSemRota: {
            show: true,
            data: { clientesSemRotaDeEntrega, rotasEntrega },
          },
        })
      } else {
        // type === Success
        this.setState({ entregas: sortBy(payload, 'sequence') })
        this.props.dispatch(showMessageBox('Operação realizada com sucesso !', null))
      }
    } catch (e) {
      this.props.dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      this.props.dispatch(hideLoadingBox())
    }
  }

  _obterClienteComQteSku = (entregas, orderByRota = false) => {
    const result = []
    const codes = new Set(entregas.map(e => e.company_code))
    codes.forEach(code => {
      const rows = entregas.filter(e => e.company_code === code)
      const rota = rows[0].rota
      const qte_sku = rows.reduce((acc, item) => acc + item.qteSkuTotal, 0)
      result.push({ company_code: code, qte_sku, rota })
    })

    return orderByRota
      ? // ordenar por rota ASC e qte_sku DESC
        _.orderBy(result, ['rota', 'qte_sku'], ['asc', 'desc'])
      : // ordenar por qte_sku DESC
        _.orderBy(result, ['qte_sku'], ['desc'])
  }

  _checkIfAllEntregaTemAreaAssociada = () => {
    const { entregas } = this.state
    entregas.forEach(e => {
      const { area } = e
      if (area && area.id == null) {
        throw new Error(
          `Existe entrega SEM Área de Separação associada.
                        Verifique a entrega: ${e.identifier}`,
        )
      }
    })
  }

  _buildInfo = () => {
    const { entregas } = this.state
    const info = []
    entregas.forEach(e => {
      const {
        delivery_step_id,
        area: { id },
        area_nickname,
      } = e
      info.push({ delivery_step_id, area_id: id, area_nickname })
    })
    return info
  }

  _closeModalClienteRotaEntrga = () => {
    this.setState({
      modalClienteSemRota: {
        show: false,
        data: {
          clientesSemRotaDeEntrega: [],
          rotasEntrega: [],
        },
      },
    })
  }
}

const mapStateToProps = ({ picking: { selectedPicking } }) => ({ selectedPicking })
export default connect(mapStateToProps)(withRouter(AssocAreaSeparacao))
